<app-breadcrumbs [data]="breadcrumbs"></app-breadcrumbs>
<app-progress></app-progress>
<div class="mat-typography mt-4">
    <mat-card class="w-full md:w-1/2 mx-auto bg-gray-50 p-4">
        <mat-card-header>
            <mat-card-title>
                Account
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <form (ngSubmit)="submit().then()" [formGroup]="accountForm">
                <mat-form-field class="form-field-full-width">
                    <input class="form-group" formControlName="name" matInput placeholder="Account name" required
                           type="text">
                    <mat-error>Name is required</mat-error>
                </mat-form-field>
                <div class="button-row">
                    <button [disabled]="accountForm.invalid" color="primary" mat-raised-button type="submit">Save
                    </button>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
</div>
